import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Grid,
    Row,
    Col,
} from "react-bootstrap";
import { MdClose } from "react-icons/md";
import { Card } from "components/Card/Card.jsx";
import { Modal } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import SimpleReactValidator from 'simple-react-validator';
import ReactJson from "react-json-view";
import APIToken from "../Brands/APIToken";
import { brandActions } from "../../../redux/actions/brand-actions";
import BrandsDropdownLinks from "../Brands/BrandsDropdownLinks";
import { hasPermission } from 'helper/hasPermission';
import ConfigurationEmails from "./ConfigurationEmails";
import SFTP_Configuration from "./SFTP_Configuration";
// var CryptoJS = require("crypto-js");
// var Base64 = require('js-base64').Base64;

var cloneDeep = require('lodash.clonedeep');
let _ = require('lodash');

class ConfigurationSettings extends Component {
    constructor(props) {
        super(props);
        const user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).result.user : undefined;
        this.validator = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
        this.state = {
            apiModal: false,
            user: user,
            rest_configuration: {
                rest_api_path: '',
                api_verb: 'POST',
                api_request_sample: {
                },
                api_success_response_sample: {

                },
                api_failure_response_sample: {
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                    'Accept-Encoding': 'gzip, deflate',
                    'Connection': 'keep-alive',
                    'cache-control': 'no-cache',
                },
            },
            brand_name: '',
            apiUrl_copied: false,
            Headers_copied: false,
            sample_request_copied: false,
            success_response_copied: false,
            failure_response_copied: false,
            copied: false,
            model_id: '',
            brand_settings: null,
            // STEP 1 api
            rest_first_step: {
                rest_api_path: `${process.env.REACT_APP_HOST_NAME}/api/authenticate`,
                api_verb: 'POST',
                api_request_sample: {
                },
                api_success_response_sample: {
                    result: {
                        Token: "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
                    },
                    status: 'success',
                    message: 'Login Successful'

                },
                api_failure_response_sample: {
                    result: [],
                    status: 'errors',
                    message: ['Invalid Credentials']
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                    'Accept-Encoding': 'gzip, deflate',
                    'Connection': 'keep-alive',
                    'cache-control': 'no-cache',
                },
            },
        }
        this.configurationEmailsRef = React.createRef();
    }


    componentDidMount() {
        if (this.state.user !== undefined) {
            if (this.state.user.roles[0].name === 'brand manager') {
                this.setState({
                    model_id: this.state.user.model_id
                }, () => {
                    this.props.getBrandSettingsCall('brand', this.state.user.model_id);
                })
            }

            else if (this.state.user.roles[0].name === 'customer manager') {
                this.props.getBrandSettingsCall('customer', this.state.user.model_id);
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.brand_settings !== prevProps.brand_settings && this.props.brand_settings !== undefined) {
            const { brand_settings } = this.props;
            // let stateVar = cloneDeep(this.state);
            // var keys = Object.keys(brand_settings).forEach((item, index) => {
            //     if (!Array.isArray(brand_settings[item])) {
            //         if (typeof brand_settings[item] === 'object') {
            //             stateVar = {
            //                 ...stateVar,
            //                 [item]: {
            //                     ...stateVar[item],
            //                     ...brand_settings[item]
            //                 }
            //             }
            //         }
            //         else {
            //             stateVar = {
            //                 ...stateVar,
            //                 [item]: brand_settings[item]
            //             }
            //         }
            //     }
            //     else if (brand_settings[item].length > 0) {
            //         stateVar = {
            //             ...stateVar,
            //             [item]: brand_settings[item][0]
            //         }
            //     }
            // });
            // const { administrative_email, technical_email } = brand_settings;
            this.setState({
                brand_settings: cloneDeep(brand_settings)
            })

        }
    }

    getModelId = (id) => {
        this.setState({
            model_id: id,
        }, () => {
            this.props.getBrandSettingsCall('brand', this.state.model_id);
        })
    }

    returnJson = (data) => {
        return <ReactJson
            displayDataTypes={false}
            displayObjectSize={false}
            enableClipboard={false}
            name={false}
            src={data} />
    }
    onSubmitHandler = (e) => {
        let obj = {};
        const configurationEmails = this.configurationEmailsRef.current;
        const sftp_configure = this.ctrl_PA.returnSftpState();
        obj = {
            ...configurationEmails.state
        }
        if (sftp_configure) {
            obj = {
                ...obj,
                ...sftp_configure
            }
        }

        if (this.validator.allValid()) {
            if (configurationEmails.state.administrative_email_valid && configurationEmails.state.technical_email_valid) {
                // if (configurationEmails.state.administrative_email_array.length > 0 && configurationEmails.state.technical_email_array.length > 0) {
                console.log('before call', this.state.model_id)
                this.props.updateBrandSettingsCall('', obj).then(res => {
                    if (res.status === 'success') {
                        if (this.state.user.roles[0].name === 'customer manager') {
                            this.props.getBrandSettingsCall('customer', this.state.user.model_id);
                        }
                        else {
                            console.log('alsdjk', this.state.model_id)
                            this.props.getBrandSettingsCall('brand', this.state.model_id);
                        }
                    }
                })
                // }
                // else {
                //     console.log('email is required');
                //     this.setState({
                //         // administrative_email_valid: false
                //     });
                // }
            }
            else {
                console.log('emails are invalid')
            }
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }

    }


    render() {
        return (
            <Grid fluid>
                <Row>
                    <Col md={12}>
                        <Card
                            ctTableResponsive
                            content={
                                <div>
                                    {(this.state.user.roles[0].name === 'super admin' || this.state.user.roles[0].name === 'zabin Staff') &&
                                        <div
                                            className="col-md-4 pull-right"
                                        >
                                            <BrandsDropdownLinks
                                                returnModelId={this.getModelId}
                                                selectFirst="true"
                                            />
                                        </div>
                                    }

                                    <Grid fluid>
                                        <Row>
                                            {
                                                (this.state.brand_settings) && (hasPermission('edit-configuration-settings-emails') || (this.state.user.roles[0].name === 'customer manager')) &&
                                                <ConfigurationEmails
                                                    admin_email={this.state.brand_settings.administrative_email}
                                                    tech_email={this.state.brand_settings.technical_email}
                                                    ref={this.configurationEmailsRef}
                                                />
                                            }

                                            {
                                                this.state.brand_settings && hasPermission('view-configuration-settings') &&
                                                <SFTP_Configuration
                                                    brand_settings={this.state.brand_settings}
                                                    provideCtrl={ctrl => this.ctrl_PA = ctrl}
                                                />
                                            }
                                            <Col md={12} className="mt-xlg">

                                                {
                                                    this.state.brand_settings &&
                                                    !_.isEmpty(this.state.brand_settings.rest_configuration) &&
                                                    hasPermission('view-configuration-settings') &&
                                                    <React.Fragment>

                                                        <div className="apiField larger">
                                                            Step 1: Authenticate to get API Token
                                                        </div>
                                                        <hr />
                                                        <APIToken hideButtons={true} authentication_api={true} rest_conf={{
                                                            ...this.state.rest_first_step, api_request_sample: {
                                                                user_name: this.state.brand_settings.user_name,
                                                                password: this.state.brand_settings.password,
                                                            }
                                                        }} />
                                                    </React.Fragment>
                                                }
                                                {
                                                    this.state.brand_settings &&
                                                    !_.isEmpty(this.state.brand_settings.rest_configuration) && hasPermission('view-configuration-settings') &&
                                                    <React.Fragment>

                                                        <div className="apiField larger">
                                                            {/* REST API Configuration */}
                                                            Step 2: Sync Product data using the API Token received in Step 1
                                                        </div>
                                                        <hr />
                                                        <APIToken hideButtons={true} rest_conf={this.state.brand_settings.rest_configuration} />
                                                    </React.Fragment>
                                                }

                                                {
                                                    (this.state.brand_settings || this.state.user.roles[0].name === 'customer manager') &&
                                                    <div className="text-center mt-xlg">
                                                        <button className="customBtn btnBlack m-md"
                                                            type="button" onClick={() => { this.props.history.goBack() }}>
                                                            Exit
                                                        </button>
                                                        {
                                                            hasPermission('view-configuration-settings') &&
                                                            !_.isEmpty(this.state.brand_settings.rest_configuration) &&
                                                            <button className="customBtn btnBlue m-md"
                                                                type="button"
                                                                onClick={() => { this.setState({ apiModal: !this.state.apiModal }) }}>
                                                                Show Code
                                                            </button>
                                                        }
                                                        {
                                                            this.state.user.roles[0].name !== 'customer manager' &&
                                                            <button className="customBtn btnBlue m-md"
                                                                type="button"
                                                                onClick={this.onSubmitHandler}>
                                                                Update Settings
                                                            </button>
                                                        }
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                    </Grid>
                                </div>
                            }
                        />

                        <Modal show={this.state.apiModal} aria-labelledby="ModalHeader">
                            <Modal.Body style={{ wordBreak: 'break-all' }}>
                                <span className="modalCloseBtn" onClick={() => { this.setState({ apiModal: !this.state.apiModal }) }}><MdClose /></span>
                                <div className="modalCode p-md text_16">
                                    <div>POST: {process.env.REACT_APP_SYNC_URL}</div> <br />
                                    <div>Host: {process.env.REACT_APP_SFTP_HOST}</div> <br />
                                    <div>Authorization: XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</div> <br />
                                    <div>Accept: */*</div>
                                    <div>Cache-Control: no-cache</div>
                                    <div>Accept-Encoding: gzip, deflate</div>
                                    <div>Connection: keep-alive</div>
                                    <div>Content-Type: application/x-www-form-urlencoded</div>
                                    <div>
                                        {
                                            !_.isEmpty(this.state.brand_settings) ?
                                                this.state.brand_settings.rest_configuration && this.state.brand_settings.rest_configuration.api_request_sample &&
                                                <div>
                                                    {this.returnJson(this.state.brand_settings.rest_configuration.api_request_sample)}
                                                </div>
                                                : null
                                        }
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </Col>
                </Row>
            </Grid>
        );
    }
}


const mapDispatchToProps = dispatch => {
    return ({
        getBrandSettingsCall: (model, brandId) => { dispatch(brandActions.getBrandSettings(model, brandId)) },
        updateBrandSettingsCall: (brandId, data) => { return dispatch(brandActions.updateBrandSettings(brandId, data)) },
    });
};


function mapStateToProps(state) {
    const { brand_settings } = state.brandReducer;
    return {
        brand_settings
    };
}

ConfigurationSettings.defaultProps = {
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfigurationSettings));



// WEBPACK FOOTER //
// ./src/components/Admin/Settings/ConfigurationSettings.jsx